export const contract = {
  Contract: 'Contrato',
  'Contracted areas': 'Áreas contratadas',
  Details: 'Detalles',
  Payments: 'Pagos',
};
